export function generateQuery(obj) {
  let queryObj = clearQuery(obj);
  let queryString = "?";
  Object.keys(queryObj).forEach((key, index) => {
    if (key === "q") {
      if (index === 0) {
        queryString = queryString.concat(`${queryObj[key]}`);
      } else {
        queryString = queryString.concat(`&${queryObj[key]}`);
      }
    } else {
      if (index === 0) {
        queryString = queryString.concat(`${key + "=" + queryObj[key]}`);
      } else {
        queryString = queryString.concat(`&${key + "=" + queryObj[key]}`);
      }
    }
  });
  queryString.length === 1 ? (queryString = "") : "";
  return queryString;
}

function clearQuery(queryObj) {
  let newQuery = {};
  Object.keys(queryObj).forEach(key => {
    if (queryObj[key]) {
      newQuery[key] = queryObj[key];
    }
  });
  return newQuery;
}
